// campaign-pause-cue.ts — the sound of the GM pausing campaign time (owner request 2026-09-02, the
// "FT3D player pause request" packet: SoundForge specs/ft3d-player-pause-wishlist.json, pool `time__pause`).
//
// A pause writes no roll row, so no resolver branch can reach it (same as the map ping and doors). The clock
// runtime (campaign-time-init/campaign-clock-runtime.ts) owns the running→paused EDGE — on the GM tab that is
// its own optimistic pause, on every other tab the pushed blob — and calls window.ftPlayCampaignPauseCue once
// per edge. It lives in this bundle, not the clock's, because playCampaignCue's mixer state is per bundle.
//
// The take comes from the catalog's 'time/pause' pool, which holds APPROVED takes only (audio_catalog_inc.php
// filters audio_private = 0): until one is approved in sfx_review.php this is silence, never an error.
import { loadAudioCatalog, pickAudioTake, seededRandom } from '../shared/audio-catalog';
import { playCampaignCue } from './roll-audio-mixer';

const PAUSE_POOL = 'time/pause';

/** Play the pause cue once. The caller owns the edge detection; the seed makes the whole table pick the same take. */
async function playCampaignPauseCue(seed: string): Promise<void> {
    try {
        const catalog = await loadAudioCatalog();
        if (!catalog) return;
        const take = pickAudioTake(catalog, [[PAUSE_POOL]], seededRandom(`${String(seed).toUpperCase()}|pause`));
        if (take) playCampaignCue(take.url);
    } catch {
        // a missing pause sound never blocks the pause
    }
}

(window as unknown as { ftPlayCampaignPauseCue?: typeof playCampaignPauseCue }).ftPlayCampaignPauseCue = playCampaignPauseCue;

export { playCampaignPauseCue };
